"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SideBySideToolbar = void 0;
var react_1 = __importDefault(require("react"));
var PreBuiltToolBarOptions_1 = require("Common/AtomicUI/ToolBarComponent/PreBuiltToolBarOptions");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var LegacyToolbarShim_1 = require("../../../../../../CommonFrontend/Toolbar/LegacyToolbarShim");
var SideBySideToolbar = function (_a) {
    var onDeleteClick = _a.onDeleteClick, onDeleteMouseEnter = _a.onDeleteMouseEnter, onDeleteMouseLeave = _a.onDeleteMouseLeave, onContextualStyleClick = _a.onContextualStyleClick;
    return (react_1.default.createElement("div", { className: "side-by-side__toolbar", contentEditable: false },
        react_1.default.createElement(kaleidoscope_1.Toolbar, { visible: true, positionType: kaleidoscope_1.ToolbarPositionType.None }, [
            __assign(__assign({}, (0, PreBuiltToolBarOptions_1.DeleteOption)(onDeleteClick)), { onMouseEnter: onDeleteMouseEnter, onMouseLeave: onDeleteMouseLeave }),
        ].map(LegacyToolbarShim_1.shimLegacyToolbarOption))));
};
exports.SideBySideToolbar = SideBySideToolbar;
